import CertificateElement from "./certificateElement";
import {certificateElementType} from "~/enums/certificateElementType";
import DynamicListElement from "./concerns/dynamicListElement";

export default class DynamicListCertificateElement extends DynamicListElement(CertificateElement) {
  type: certificateElementType = certificateElementType.DynamicList;
}